import { PROFILE_ENVIRONMENT, PROFILE_ID } from "./enums";
import sky_cl_chatbot_es from "./sky_cl_chatbot_es";
import sky_corporate_cl_chatbot_es from "./sky_corporate_cl_chatbot_es";
import sky_pe_chatbot_es from "./sky_pe_chatbot_es";

const profiles = [
  sky_cl_chatbot_es,
  sky_pe_chatbot_es,
  sky_corporate_cl_chatbot_es,
];

export const findProfile = (
  id: PROFILE_ID,
  environment: PROFILE_ENVIRONMENT
) => {
  const profile = profiles.find((profile) => profile.chatbotId === id);

  if (!profile) throw new Error(`Profile with id ${id} not found`);

  const environmentCredentials = profile.credentials.find(
    (credential) => credential.environment === environment
  );

  if (!environmentCredentials)
    throw new Error(
      `Profile with id ${id} and environment ${environment} not found`
    );

  return {
    chatbotId: profile.chatbotId,
    ...environmentCredentials,
  };
};
